module.exports = __webpack_public_path__ + "static/media/E702.39b4a200.png";